/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_DeletedInputs */

const en_settings_apikeys_deleted = /** @type {(inputs: Settings_Apikeys_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key deleted`)
};

/**
* | output |
* | --- |
* | "Key deleted" |
*
* @param {Settings_Apikeys_DeletedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_deleted = /** @type {((inputs?: Settings_Apikeys_DeletedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_DeletedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_deleted(inputs)
});
export { settings_apikeys_deleted as "settings.apikeys.deleted" }